export enum Environment {
  Development = 'development',
  Production = 'production',
  Test = 'test',
}
